import { useReactiveVar } from "@apollo/client";
import { Left } from "./left";
import { Right } from "./right";
import * as Styles from "~/components/blocks/layout/global-navi/common/common-style";
import { Skeleton } from "~/components/blocks/layout/global-navi/skeleton";
import { dmmServiceListDataVar } from "~/components/blocks/layout/store";
import { isBot } from "~/util/is-bot";

export const Desktop = () => {
  const dmmServiceListData = useReactiveVar(dmmServiceListDataVar);
  const element = (
    <Styles.HeaderWrapper>
      <Left />
      <Right />
    </Styles.HeaderWrapper>
  );

  if (isBot()) return element;

  return dmmServiceListData.length !== 0 ? <>{element}</> : <Skeleton />;
};
